import { useSlugParams } from "hooks/useUrlParams";
import * as React from "react";
import { useAsync } from "react-use";
import { apiClient } from "utils/apiClient";

interface ContextValue {
	loading: boolean;
	value?: any;
}
const ctx = React.createContext<ContextValue>({ loading: false });

export const OrganizationProvider = ({ children }) => {
	const slug = useSlugParams();
	const url = `admin/organizations/${slug}`;

	const result = useAsync(async () => {
		const response = await apiClient(url);
		return response.data;
	}, [url]);
	const value = React.useMemo(() => result, [result]);

	return <ctx.Provider value={value}>{children}</ctx.Provider>;
};

export function useOrganizationContext(): ContextValue {
	const context = React.useContext(ctx);
	if (!context) {
		throw new Error("useOrganizationContext must be put within OrganizationProvider");
	}
	return context;
}
